'use client';

interface Matter {
  category: string;
  title: string;
  description: string;
}

const matters: Matter[] = [
  {
    category: '01 / Personal Injury',
    title: 'Multi-vehicle collision recovery',
    description: 'Comprehensive case preparation and negotiation strategy for a client sustaining serious injuries in a commercial vehicle accident.',
  },
  {
    category: '02 / Business Litigation',
    title: 'Partnership dissolution dispute',
    description: 'Strategic commercial counsel for a technology firm navigating a complex ownership and intellectual property disagreement.',
  },
  {
    category: '03 / Employment Law',
    title: 'Workplace discrimination matter',
    description: 'Decisive advocacy for an employee facing systemic discrimination, resulting in a favorable settlement and policy reform.',
  },
  {
    category: '04 / Real Estate',
    title: 'Commercial lease renegotiation',
    description: 'Expert representation for a retail business securing favorable lease terms during a challenging commercial real estate environment.',
  },
];

export default function MatterSection() {
  return (
    <section id="selected-matters" className="matter-section section-space">
      <div className="site-container">
        <div className="centered-heading centered-heading-light">
          <p className="eyebrow">Selected matters</p>
          <h2>A Tradition of <em>Prepared Advocacy</em></h2>
          <p>Representative matter types reflecting our depth of experience across practice areas.</p>
        </div>
        <div className="matter-grid">
          {matters.map((matter, i) => (
            <article key={i} className="matter-card">
              <span>{matter.category}</span>
              <h3>{matter.title}</h3>
              <p>{matter.description}</p>
              <i />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
